import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';

import { BcStateListContext } from '@bayclubs/state';
import { ClubModel, CourtModel, EnumerationModel, CategoryOptionsModel, CourtTimeSlotModel } from '@bayclubs/court-booking-employee-api';

import * as actions from './core.actions';
import { CoreSelectors } from './core.selectors';

@Injectable({ providedIn: 'root' })
export class CoreFacade {
    @Select(CoreSelectors.clubs) clubs$: Observable<BcStateListContext<ClubModel>>;
    @Select(CoreSelectors.manageableClubs) manageableClubs$: Observable<ClubModel[]>;
    @Select(CoreSelectors.courtEventStatuses) courtEventStatuses$: Observable<BcStateListContext<EnumerationModel>>;
    @Select(CoreSelectors.categories) categories$: Observable<BcStateListContext<EnumerationModel>>;
    @Select(CoreSelectors.tennisCourtTypes) tennisCourtTypes$: Observable<BcStateListContext<EnumerationModel>>;
    @Select(CoreSelectors.categoriesOptions) categoriesOptions$: Observable<BcStateListContext<CategoryOptionsModel>>;
    @Select(CoreSelectors.courtTimeSlots) courtTimeSlots$: Observable<BcStateListContext<CourtTimeSlotModel>>;
    @Select(CoreSelectors.courtVisibilityOptions) courtVisibilityOptions$: Observable<BcStateListContext<EnumerationModel>>;

    @Select(CoreSelectors.selectedClub) selectedClub$: Observable<ClubModel>;
    selectedClubSignal = inject(Store).selectSignal(CoreSelectors.selectedClub);
    @Select(CoreSelectors.clubCourts) clubCourts$: Observable<BcStateListContext<CourtModel>>;

    constructor(private state: Store) {}

    clubsSnapshot = () => this.state.selectSnapshot(CoreSelectors.clubs);
    selectedClub = () => this.state.selectSnapshot(CoreSelectors.selectedClub);
    clubCourtsSnapshot = () => this.state.selectSnapshot(CoreSelectors.clubCourts);

    loadContext = () => this.state.dispatch(new actions.LoadContextAction());
    selectedClubChanged = (clubId: string = null) => this.state.dispatch(new actions.SelectedClubChanged(clubId));
    setUpClubContext = (clubId: string = null) => this.state.dispatch(new actions.SetUpClubContext(clubId));
    loadClubCourts = (club: ClubModel) => this.state.dispatch(new actions.LoadClubCourtsAction(club));
}
